import React, { Component, Fragment, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import MetisMenu from "react-metismenu";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import {
  LoginNav,
  LoginNavWithOrg,
  LoginNavWithOrgIsNotSupporter,
  LoginNavWithOrgIsSupporter,
  LoginNavWithoutSupporterAndCso,
  NotLoginNav,
  NotLoginNavMobile,
} from "./NavItems";

import {
  useLoginStatus,
  useOrgPk,
  useUserEmail,
} from "../AppMain/LoginStatusContext";
import logo from "../../assets/utils/images/originals/logo_produced_by_ema.png";
import { useQuery } from "@apollo/client";
import { CHECK_USER_STATUS, QUERY_ALL_USER } from "../../queries";

import "./verticalNavWrapper.css";

const Nav = () => {
  const loginUser = useLoginStatus();
  const orgId = useOrgPk();

  const user = useQuery(QUERY_ALL_USER, {
    variables: { email: useUserEmail() },
  });

  const userStatus = useQuery(CHECK_USER_STATUS, {
    variables: { email: useUserEmail() },
  });

  const [enableMobileMenu, setEnableMobileMenu] = useState({});
  // ナビゲーション切り替え用
  // const [login, setLogin] = useState(false);

  const toggleMobileSidebar = () => {
    setEnableMobileMenu(!enableMobileMenu);
  };

  const sidebar_wrap_style = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  };

  return (
    <Fragment>
      <h5 className="app-sidebar__heading">Menu</h5>
      {loginUser ? (
        <div style={sidebar_wrap_style}>
          {!userStatus?.data?.allUsers?.edges[0]?.node?.isCso &&
          !userStatus?.data?.allUsers?.edges[0]?.node?.isSupporter ? (
            <div style={sidebar_wrap_style}>
              <MetisMenu
                content={LoginNavWithoutSupporterAndCso}
                onSelected={toggleMobileSidebar}
                activeLinkFromLocation
                className="vertical-nav-menu"
                iconNamePrefix=""
                classNameStateIcon="pe-7s-angle-down"
              />
              <p
                style={{
                  color: "#adaeaf",
                  // position: "absolute",
                  bottom: 0,
                  right: 30,
                  textAlign: "center",
                  marginBottom: "1rem",
                }}
              >
                <img src={logo} alt="サイドバーロゴ" style={{ width: "70%" }} />
              </p>
            </div>
          ) : orgId !== "このユーザーは組織と紐づいていません" ? (
            <div style={sidebar_wrap_style}>
              {!user?.loading && !user?.error && (
                <MetisMenu
                  content={
                    user?.data?.allUsers?.edges[0]?.node?.isSupporter
                      ? LoginNavWithOrgIsSupporter
                      : LoginNavWithOrgIsNotSupporter
                  }
                  onSelected={toggleMobileSidebar}
                  activeLinkFromLocation
                  className="vertical-nav-menu"
                  iconNamePrefix=""
                  classNameStateIcon="pe-7s-angle-down"
                />
              )}
              <p
                style={{
                  color: "#adaeaf",
                  // position: "absolute",
                  bottom: 0,
                  right: 30,
                  textAlign: "center",
                  marginBottom: "1rem",
                }}
              >
                <img src={logo} alt="サイドバーロゴ" style={{ width: "70%" }} />
              </p>
            </div>
          ) : (
            <div style={sidebar_wrap_style}>
              <MetisMenu
                content={LoginNav}
                onSelected={toggleMobileSidebar}
                activeLinkFromLocation
                className="vertical-nav-menu"
                iconNamePrefix=""
                classNameStateIcon="pe-7s-angle-down"
              />
              <p
                style={{
                  color: "#adaeaf",
                  // position: "absolute",
                  bottom: 0,
                  right: 30,
                  textAlign: "center",
                  marginBottom: "1rem",
                }}
              >
                <img src={logo} alt="サイドバーロゴ" style={{ width: "70%" }} />
              </p>
            </div>
          )}
        </div>
      ) : (
        <div style={sidebar_wrap_style}>
          <div className="desktop">
            <MetisMenu
              content={NotLoginNav}
              onSelected={toggleMobileSidebar}
              activeLinkFromLocation
              className="vertical-nav-menu"
              iconNamePrefix=""
              classNameStateIcon="pe-7s-angle-down"
            />
          </div>
          <div className="smartphone">
            <MetisMenu
              content={NotLoginNavMobile}
              onSelected={toggleMobileSidebar}
              activeLinkFromLocation
              className="vertical-nav-menu"
              iconNamePrefix=""
              classNameStateIcon="pe-7s-angle-down"
            />
          </div>
          <p
            style={{
              color: "#adaeaf",
              // position: "absolute",
              bottom: 0,
              right: 30,
              textAlign: "center",
              marginBottom: "1rem",
            }}
          >
            <img src={logo} alt="サイドバーロゴ" style={{ width: "70%" }} />
          </p>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));
